import FacetBlock from "./FacetBlock";

export default FacetBlock;
